<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="headline">
                Selamat Datang,
                <b>{{user.name}}</b>
              </v-list-item-title>
              <v-list-item-subtitle>Anda terakhir login {{$format.dateRelative(user.lastLogin)}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <!-- <v-card-text>
            <v-row align="center">
              <v-col class="display-3" cols="6">23&deg;C</v-col>
              <v-col cols="6">
                <v-img
                  src="https://cdn.vuetifyjs.com/images/cards/sun.png"
                  alt="Sunny image"
                  width="92"
                ></v-img>
              </v-col>
            </v-row>
          </v-card-text>-->
        </v-card>
      </v-col>
      <!-- <v-card :cols="6" :sm="6">
        <v-list-item two-line>
          <v-list-item-content>
            <v-list-item-title class="headline"
              >San Francisco</v-list-item-title
            >
            <v-list-item-subtitle
              >Mon, 12:30 PM, Mostly sunny</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>

        <v-card-text>
          <v-row align="center">
            <v-col class="display-3" cols="6">
              23&deg;C
            </v-col>
            <v-col cols="6">
              <v-img
                src="https://cdn.vuetifyjs.com/images/cards/sun.png"
                alt="Sunny image"
                width="92"
              ></v-img>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>-->
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg"
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg"
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg"
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg"
        }
      ]
    };
  },
  computed: {
    user() {
      return this.$session.get.user();
    }
  }
};
</script>

<style>
</style>